import { useJobsStore } from '../jobsStore';

/**
 * Ticker pro živé doby běhu — hodnotu aktualizuje `JobsRuntime` (1× za sekundu, jen když
 * nějaký job běží), takže komponenty se překreslují společně a bez vlastních intervalů.
 */
export function useNow(): number {
  return useJobsStore((s) => s.now);
}
